import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import './LogRocketLabel.scss';
import PortalContainer from '../PortalContainer';

const LogRocketLabel: FC<{ isShow: boolean }> = ({ isShow }) => {
  const { t } = useTranslation();

  const isInIframe = () => {
    return window.location !== window.parent.location;
  };

  return (
    <PortalContainer className="rocket-log-wrap" isCheckModalOpened={false}>
      {isShow && !isInIframe() ? <div className="rocket-log">{t('common.logrocketPhrase')}</div> : null}
    </PortalContainer>
  );
};

export default LogRocketLabel;
